var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindchatB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5C16.3807 15.5 17.5 14.3807 17.5 13C17.5 11.6193 16.3807 10.5 15 10.5C13.6193 10.5 12.5 11.6193 12.5 13C12.5 14.3807 13.6193 15.5 15 15.5Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L19 17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.2C0 4.68 0 3.42 0.49 2.457C0.921469 1.61005 1.61005 0.921469 2.457 0.49C3.42 0 4.68 0 7.2 0H12.8C15.32 0 16.58 0 17.543 0.49C18.39 0.921469 19.0785 1.61005 19.51 2.457C20 3.42 20 4.68 20 7.2V10.706C19.6298 9.90019 19.0701 9.19585 18.3689 8.65303C17.6676 8.11022 16.8455 7.74502 15.9726 7.58857C15.0997 7.43212 14.2019 7.48906 13.3558 7.75453C12.5097 8.02001 11.7403 8.48615 11.1132 9.11321C10.4861 9.74028 10.02 10.5097 9.75453 11.3558C9.48906 12.2019 9.43212 13.0997 9.58857 13.9726C9.74502 14.8455 10.1102 15.6676 10.653 16.3689C11.1959 17.0701 11.9002 17.6298 12.706 18H3.2C2.08 18 1.52 18 1.092 17.782C0.715693 17.5903 0.409744 17.2843 0.218 16.908C-5.96046e-08 16.48 0 15.92 0 14.8V7.2ZM4 7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H11C11.2652 6 11.5196 6.10536 11.7071 6.29289C11.8946 6.48043 12 6.73478 12 7C12 7.26522 11.8946 7.51957 11.7071 7.70711C11.5196 7.89464 11.2652 8 11 8H5C4.73478 8 4.48043 7.89464 4.29289 7.70711C4.10536 7.51957 4 7.26522 4 7ZM4 11C4 10.7348 4.10536 10.4804 4.29289 10.2929C4.48043 10.1054 4.73478 10 5 10H8C8.26522 10 8.51957 10.1054 8.70711 10.2929C8.89464 10.4804 9 10.7348 9 11C9 11.2652 8.89464 11.5196 8.70711 11.7071C8.51957 11.8946 8.26522 12 8 12H5C4.73478 12 4.48043 11.8946 4.29289 11.7071C4.10536 11.5196 4 11.2652 4 11Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindchatB);
export default __webpack_public_path__ + "static/media/findchat_b.cfedd7c9c73cb4e87f7cae7b23df0039.svg";
export { ForwardRef as ReactComponent };